
const constants ={
    TYPE_ERROR: 'error',
    TYPE_WARN: 'warning',
    TYPE_SUCCESS: 'success'
}

export default constants